import { INotification } from './types'

const firstString = (...values: unknown[]): string | null => {
  const value = values.find((candidate) => typeof candidate === 'string' && candidate.trim())
  return typeof value === 'string' ? value.trim() : null
}

const asRecord = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : {}

const firstRecord = (...values: unknown[]): Record<string, unknown> => {
  const value = values.find((candidate) => candidate && typeof candidate === 'object' && !Array.isArray(candidate))
  return value ? (value as Record<string, unknown>) : {}
}

const getPayload = (notification: INotification): Record<string, unknown> => asRecord(notification.data)

const getObjectRef = (notification: INotification): Record<string, unknown> => {
  const payload = getPayload(notification)
  return firstRecord(notification.object_ref, payload.object_ref, payload.objectRef)
}

export const getNotificationSemanticKey = (notification: INotification): string | null => {
  const payload = getPayload(notification)
  const objectRef = getObjectRef(notification)
  const service = firstString(notification.service, payload.service)
  const eventType = firstString(notification.event_type, payload.event_type, payload.eventType)
  const entityId = firstString(
    objectRef.reply_cid,
    objectRef.cid,
    objectRef.comment_id,
    objectRef.commentId,
    objectRef.parent_cid,
    objectRef.parentCid,
    objectRef.pop_id,
    objectRef.popId,
    objectRef.service_call_id,
    objectRef.service_call_number,
    objectRef.serviceCallId,
    objectRef.serviceCallNumber,
    objectRef.st_id,
    objectRef.subtask_id,
    objectRef.subTaskId,
    objectRef.tid,
    objectRef.task_id,
    objectRef.taskId,
    objectRef.post_id,
    objectRef.oid,
    objectRef.object_id,
    objectRef.objectId,
    objectRef.id,
    payload.reply_cid,
    payload.cid,
    payload.comment_id,
    payload.parent_cid,
    payload.pop_id,
    payload.service_call_id,
    payload.service_call_number,
    payload.st_id,
    payload.subtask_id,
    payload.tid,
    payload.task_id,
    payload.post_id,
    payload.oid,
    payload.object_id,
    payload.entityId
  )

  if (!service || !eventType || !entityId) return null

  return `semantic:${service}:${eventType}:${entityId}`
}
